import server from '../../api/server';

export class CompleteSessionService {
    static async completeSession(token: string, consultId: number): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.put(
              `staff/nutrition-consult/complete/${consultId}`,
              JSON.stringify(""),
              {headers}
            );

            if (responseServer.data.statusCode != 200) {
                console.log("ERROR");
            }

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response.status);
        }
    }
}
